import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneRender',
})
export class PhoneRenderPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    if (typeof value === 'string') {
      if (value.length === 12) {
        return (
          value.substring(0, 3) +
          ' ' +
          value.substring(3, 4) +
          ' ' +
          value.substring(4, 6) +
          ' ' +
          value.substring(6, 8) +
          ' ' +
          value.substring(8, 10) +
          ' ' +
          value.substring(10)
        );
      } else if (value.length === 13) {
        return (
          value.substring(0, 4) +
          ' ' +
          value.substring(4, 5) +
          ' ' +
          value.substring(5, 7) +
          ' ' +
          value.substring(7, 9) +
          ' ' +
          value.substring(9, 11) +
          ' ' +
          value.substring(11)
        );
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
}
